import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  ref: "element",
  id: "editGroupModal",
  "data-bs-backdrop": "static",
  tabindex: "-1",
  "aria-labelledby": "editGroupModalLabel",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-fullscreen" }
const _hoisted_3 = { class: "modal-content modal-content-rounded" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  key: 0,
  class: "modal-title",
  id: "editGroupModalLabel"
}
const _hoisted_6 = {
  key: 1,
  class: "modal-title",
  id: "editGroupModalLabel2"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Lukk"
}, null, -1)
const _hoisted_8 = { class: "modal-body" }
const _hoisted_9 = { class: "form-floating mb-3" }
const _hoisted_10 = { class: "form-label" }
const _hoisted_11 = { class: "invalid-feedback mb-3" }
const _hoisted_12 = { class: "form-floating mb-3" }
const _hoisted_13 = { class: "form-label" }
const _hoisted_14 = { class: "form-floating mb-3" }
const _hoisted_15 = { class: "form-label" }
const _hoisted_16 = { class: "mb-3 form-check form-switch" }
const _hoisted_17 = { class: "form-check-label" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_19 = { class: "form-text" }
const _hoisted_20 = { class: "mb-3 form-check form-switch" }
const _hoisted_21 = { class: "form-check-label" }
const _hoisted_22 = { class: "modal-footer" }
const _hoisted_23 = {
  key: 0,
  class: "btn btn-primary btn-rounded btn-block",
  type: "onSubmit"
}
const _hoisted_24 = {
  key: 1,
  class: "btn btn-primary btn-rounded btn-block",
  type: "onSubmit"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-rounded btn-primary",
  "data-bs-dismiss": "modal"
}, "Avbryt", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createBlock(_Teleport, { to: "#modals" }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_ctx.form.id)
              ? (_openBlock(), _createElementBlock("h5", _hoisted_5, _toDisplayString(_ctx.t('headingEdit')), 1))
              : _createCommentVNode("", true),
            (!_ctx.form.id)
              ? (_openBlock(), _createElementBlock("h5", _hoisted_6, _toDisplayString(_ctx.t('heading')), 1))
              : _createCommentVNode("", true),
            _hoisted_7
          ]),
          _createVNode(_component_Form, {
            onSubmit: _ctx.onSubmit,
            "validation-schema": _ctx.schema,
            class: "form-vertical form-login"
          }, {
            default: _withCtx(({ errors }) => [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_Field, {
                    name: "newGroupName",
                    type: "text",
                    class: _normalizeClass(["form-control border-0", { 'is-invalid': errors.newGroupName }]),
                    id: "newGroupName",
                    modelValue: _ctx.form.newGroupName,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.newGroupName) = $event)),
                    required: "",
                    autofocus: ""
                  }, null, 8, ["class", "modelValue"]),
                  _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.t('newGroupName')), 1),
                  _createElementVNode("div", _hoisted_11, _toDisplayString(errors.newGroupName), 1)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_Field, {
                    name: "newGroupDescription",
                    type: "text",
                    class: "form-control border-0",
                    id: "newGroupDescription",
                    modelValue: _ctx.form.newGroupDescription,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.newGroupDescription) = $event)),
                    placeholder: _ctx.t('newGroupDescription')
                  }, null, 8, ["modelValue", "placeholder"]),
                  _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.t('newGroupDescription')), 1)
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_Field, {
                    name: "newGroupUrl",
                    type: "text",
                    class: "form-control border-0",
                    id: "newGroupUrl",
                    modelValue: _ctx.form.newGroupUrl,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.newGroupUrl) = $event)),
                    placeholder: _ctx.t('newGroupUrl')
                  }, null, 8, ["modelValue", "placeholder"]),
                  _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.t('externalLink')), 1)
                ]),
                _createElementVNode("legend", null, _toDisplayString(_ctx.t('settings')), 1),
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_Field, {
                    class: "form-check-input",
                    type: "checkbox",
                    role: "switch",
                    value: true,
                    id: "newGroupOpen",
                    name: "newGroupOpen",
                    modelValue: _ctx.form.newGroupOpen,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.newGroupOpen) = $event))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.t('openNetwork')), 1),
                  _hoisted_18,
                  _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.t('openNetworkDescription')), 1)
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_component_Field, {
                    class: "form-check-input",
                    type: "checkbox",
                    role: "switch",
                    value: true,
                    id: "newGroupPromote",
                    name: "newGroupPromote",
                    modelValue: _ctx.form.newGroupPromote,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.newGroupPromote) = $event))
                  }, null, 8, ["modelValue"]),
                  _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.t('visibleFeedDescription')), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_22, [
                (_ctx.form.id == '')
                  ? (_openBlock(), _createElementBlock("button", _hoisted_23, _toDisplayString(_ctx.t('create')), 1))
                  : _createCommentVNode("", true),
                (_ctx.form.id != '')
                  ? (_openBlock(), _createElementBlock("button", _hoisted_24, _toDisplayString(_ctx.t('save')), 1))
                  : _createCommentVNode("", true),
                _hoisted_25
              ])
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema"])
        ])
      ])
    ], 512)
  ]))
}